import jwtService from "services/jwtService";

export const RESET_PASS_FETCH_START = "RESET_PASS_FETCH_START";
export const RESET_PASS_FETCH_SUCCESS = "RESET_PASS_FETCH_SUCCESS";
export const RESET_PASS_FETCH_FAILURE = "RESET_PASS_FETCH_FAILURE";

export function submitResetPass({
  password,
  password_confirm,
  onSuccess,
  onError,
}) {
  return (dispatch, getState) => {
    dispatch({
      type: RESET_PASS_FETCH_START,
    });

    const { auth } = getState();

    jwtService
      .resetPassword({
        password,
        password_confirm,
        resetUrl: auth.confirm.data["reset-url"],
      })
      .then((response) => {
        onSuccess();
        return dispatch({
          type: RESET_PASS_FETCH_SUCCESS,
        });
      })
      .catch((error) => {
        onError();
        return dispatch({
          type: RESET_PASS_FETCH_FAILURE,
          payload: error,
        });
      });
  };
}
